import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './MobileTwoBanners.scss';

const MobileTwoBanners = ({data, context}) => {
  const handleButtonClick = (link) => {
    if (link) {
      console.log('Navigating to:', link);
      context.navigateTo(link);
    }
  };

  // Render background element for main banner
  const renderMainBackground = () => {
    if (!data.mainBackground) return null;

    if (data.mainBackgroundType === 'video') {
      return (
        <video autoPlay loop muted playsInline className="mobile-two-banners__banner__bg">
          <source src={data.mainBackground} type="video/mp4" />
        </video>
      );
    }

    if (data.mainBackgroundType === 'image' || data.mainBackgroundType === 'gif') {
      return <Image src={data.mainBackground} alt="" className="mobile-two-banners__banner__bg" />;
    }

    return null;
  };

  // Render background element for secondary banner
  const renderSecondaryBackground = () => {
    if (!data.secondaryBanner?.background) return null;

    if (data.secondaryBanner.backgroundType === 'video') {
      return (
        <video autoPlay loop muted playsInline className="mobile-two-banners__banner__bg">
          <source src={data.secondaryBanner.background} type="video/mp4" />
        </video>
      );
    }

    if (data.secondaryBanner.backgroundType === 'image' || data.secondaryBanner.backgroundType === 'gif') {
      return <Image src={data.secondaryBanner.background} alt="" className="mobile-two-banners__banner__bg" />;
    }

    return null;
  };

  return (
    <div className="mobile-two-banners-wrapper">
      {/* Main Banner */}
      <div
        className="mobile-two-banners__banner"
        style={{ backgroundColor: data.mainBackgroundColor }}
      >
        {renderMainBackground()}
        <div className="text-buttons">
          <div className="text">
            {data.mainText && (
              <div
                className="main-text"
                style={{ color: data.mainTextColor || '#FFFFFF' }}
                dangerouslySetInnerHTML={{ __html: data.mainText }}
              />
            )}
            {data.additionalText && (
              <div
                className="additional-text"
                style={{ color: data.additionalTextColor || '#FFFFFF' }}
                dangerouslySetInnerHTML={{ __html: data.additionalText }}
              />
            )}
            {data.secondaryText && (
              <div
                className="secondary-text"
                style={{ color: data.secondaryTextColor || '#FFFFFF' }}
                dangerouslySetInnerHTML={{ __html: data.secondaryText }}
              />
            )}
          </div>
          {data.mainButton && data.mainButton.link && (
            <button
              className={`button banner-button banner-button--${data.mainButton.style} ${data.secondaryButton && data.secondaryButton.link ? 'button--two-buttons' : ''}`}
              onClick={() => handleButtonClick(data.mainButton.link)}>
              <span>{data.mainButton.text}</span>
            </button>
          )}
          {data.secondaryButton && data.secondaryButton.link && (
            <button
              className={`button banner-button-secondary banner-button-secondary--${data.secondaryButton.style} button--two-buttons`}
              onClick={() => handleButtonClick(data.secondaryButton.link)}>
              {data.secondaryButton.text}
            </button>
          )}
        </div>
      </div>

      {/* Secondary Banner */}
      <div
        className="mobile-two-banners__banner"
        style={{ backgroundColor: data.secondaryBanner?.backgroundColor }}
      >
        {renderSecondaryBackground()}
        <div className="text-buttons">
          <div className="text">
            {data.secondaryBanner?.mainText && (
              <div
                className="main-text"
                style={{ color: data.secondaryBanner.mainTextColor || '#FFFFFF' }}
                dangerouslySetInnerHTML={{ __html: data.secondaryBanner.mainText }}
              />
            )}
            {data.secondaryBanner?.additionalText && (
              <div
                className="additional-text"
                style={{ color: data.secondaryBanner.additionalTextColor || '#FFFFFF' }}
                dangerouslySetInnerHTML={{ __html: data.secondaryBanner.additionalText }}
              />
            )}
            {data.secondaryBanner?.secondaryText && (
              <div
                className="secondary-text"
                style={{ color: data.secondaryBanner.secondaryTextColor || '#FFFFFF' }}
                dangerouslySetInnerHTML={{ __html: data.secondaryBanner.secondaryText }}
              />
            )}
          </div>
          {data.secondaryBanner?.button && data.secondaryBanner.button.link && (
            <button
              className={`button banner-button banner-button--${data.secondaryBanner.button.style}`}
              onClick={() => handleButtonClick(data.secondaryBanner.button.link)}>
              <span>{data.secondaryBanner.button.text}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileTwoBanners;

